export default angular.module('installer.auth', []).
  factory('authChecker', ($http, installerConfig) => ({
    check() {
      return $http.get(`${installerConfig.backend.url}/checkAuth`);
    }
  })).
  factory('installerAuth', ($location, $q, appStorage) => ({
    wizardTokenStorage: '',
    wizardToken: '',

    logout() {
      return $q.when(this.removeWizardToken()).
        then(() => {
          $location.path('/login');
          $location.replace();
        });
    },

    check(checkAuth) {
      return $q.when(checkAuth()).catch(error => {
        if (error.status === 403 && error.data && error.data.wizardTokenStorage) {
          this.wizardTokenStorage = error.data.wizardTokenStorage;
          return $q.reject(error);
        }
        return error;
      });
    },

    resolveWizardToken() {
      if (this.wizardToken && this.wizardToken.length > 0) {
        return $q.when(this.wizardToken);
      }

      return appStorage.get('wizardToken').then(result => {
        this.wizardToken = result || '';
        return this.wizardToken;
      });
    },

    setWizardToken(token) {
      this.wizardToken = token;
      return $q(resolve => resolve(appStorage.set('wizardToken', token)));
    },

    removeWizardToken() {
      this.wizardToken = '';
      return appStorage.remove('wizardToken');
    },

    getWizardTokenStorage() {
      return this.wizardTokenStorage;
    }

  })).
  // 'authInterceptor' is registered as httpProvider interceptor, it
  // - adds query parameter 'wizardToken' to all HTTP requests sent to Wizard backend
  // - redirect to login page in case backend responded with 403 response telling about invalid wizardToken
  factory('authInterceptor', ($q, installerAuth) => ({
    request(config) {
      if (config.url.indexOf('/api/wizard/') !== 1 || config.url.indexOf('/api/checkAuth') !== 1) {
        return installerAuth.resolveWizardToken().
          then(result => {
            if (result && result.length && result.length > 0) {
              if (!config.params) {
                config.params = {};
              }
              config.params.wizardToken = result;
            }
            return config;
          }).
          catch(() => config);
      } else {
        return config;
      }
    },

    responseError(rejection) {
      if (rejection.status === 403 && rejection.data && (rejection.data.code === 'INVALID_AUTH_TOKEN' || rejection.data.code === 'TOO_MANY_FAILED_AUTHENTICATION_ATTEMPTS')) {
        return installerAuth.logout().then(() => $q.reject(rejection));
      }
      return $q.reject(rejection);
    }
  })).
  // Listener for '$routeChangeStart' events. Every time new page is opened this listener is called, it:
  // - resolve wizardToken from URL parameter 'wizard_token' (if any) and store resolved value to the application local storage
  // - it redirects to login page in case token was not resolved from parameters and doesn't exist in local storage.
  run(($rootScope, $location, installerAuth, authChecker) => {
    const routeChangeStartCallback = $rootScope.$on('$routeChangeStart', () => {
      if ($location.url().indexOf('/login') !== 0) {
        // if route requires auth
        const wizardTokenFromUrl = $location.search().wizard_token;
        if (wizardTokenFromUrl && wizardTokenFromUrl.length && wizardTokenFromUrl.length > 0) {
          installerAuth.setWizardToken(wizardTokenFromUrl);
        } else {
          installerAuth.resolveWizardToken().then(result => {
            if (!result || !result.length || result.length === 0) {
              installerAuth.logout();
            } else if ($location.url().indexOf('/welcome') === 0) {
              installerAuth.check(authChecker.check).
                catch(() => installerAuth.logout());
            }
          });
        }
      }
    });
    $rootScope.$on('$destroy', routeChangeStartCallback);
  });



// WEBPACK FOOTER //
// ./src/blocks/app/app.auth.js